enum REGISTRATION_KIDS {
  AVAILABLE = 'AVAILABLE',
  UNREGISTERED = 'UNREGISTERED',
  NOT_TAKEN = 'NOT_TAKEN',
  COMPLETED = 'COMPLETED',
  TAKE_SURVEY = 'TAKE_SURVEY',
  REGISTERED = 'REGISTERED',
  APPROVAL_NOT_REQUIRED = 'APPROVAL_NOT_REQUIRED',
  WAITLISTED = 'WAITLISTED',
  DENIED = 'DENIED',
  CANCELLED = 'CANCELLED',
  PENDING = 'PENDING',
  REMOVED = 'REMOVED'
}

type REGISTRATION_KID_TYPES = keyof typeof REGISTRATION_KIDS;

const REGISTRATION_KID_OPTIONS = Object.keys(REGISTRATION_KIDS) as REGISTRATION_KID_TYPES[];

export {
  REGISTRATION_KIDS,
  REGISTRATION_KID_OPTIONS,
  REGISTRATION_KID_TYPES,
};
